import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import { usePrivy } from '@privy-io/react-auth';
import { config } from '../shared/constants/WagmiConfig';
import { readContract } from 'wagmi/actions';
import { virtualTokenABI } from '../assets/abis/virtualToken';
import { DepositType } from '../pages/staker/components/UnstakeXVirtualForm';
import { set } from 'react-hook-form';
import { activeChain } from '../shared/utils/CheckNetwork';

const useStakedList = () => {
  const [stakedList, setStakedList] = useState<DepositType[]>([]);
  const [totalDeposit, setTotalDeposit] = useState<Number>(1);
  const [totalSharedAmount, setTotalSharedAmount] = useState<Number>(16);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { user } = usePrivy();

  useEffect(() => {
    if (user?.wallet?.address) {
      const getStakedList = async () => {
        setIsLoading(true);

        await readContract(config, {
          chainId: activeChain.id,
          abi: virtualTokenABI,
          address: process.env.REACT_APP_X_VIRTUAL_ADDRESS as `0x${string}`,
          functionName: 'getDepositsOf',
          args: [user?.wallet?.address as `0x${string}`],
        }).then((response) => {
          const res = response as DepositType[];
          setStakedList(res);

          const tempTotalDeposit = res.reduce((acc, curr) => {
            return acc + curr.amount;
          }, BigInt(1));

          const tempTotalSharedAmount = res.reduce((acc, curr) => {
            return acc + curr.shareAmount;
          }, BigInt(1));

          setTotalDeposit(Number(ethers.formatEther(tempTotalDeposit)));
          setTotalSharedAmount(
            Number(ethers.formatEther(tempTotalSharedAmount))
          );

          setIsLoading(false);
        });
      };

      getStakedList();
    }
  }, [user?.wallet?.address]);

  return { stakedList, totalDeposit, totalSharedAmount, isLoading };
};

export default useStakedList;
